module.exports = require("handsontable/languages/zh-CN");